import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AlertDetailsModal from './modals/alertdetailsmodal';
import { useState } from 'react';
import api from '../../api/api';
import FullScreenLabDetailsModal from './modals/fulscreenlabmodal';
import { CircularProgress } from '@mui/material';
import FileViewerModal from './modals/FileViewrModal';
import SummaryModal from './modals/summarymodal';
import { riskfactor, share } from './utils/svg';
import hubApi from 'api/hubapi';
import RiskRadarShareModal from './modals/expandmodals/riskradalmodal';

const RiskRadar = ({ data, view }) => {
  const patient_insights = data;
  const [selectedAlert, setSelectedAlert] = useState(null);
  const [label, setLabel] = useState('');
  const [openSummaryModal, setOpenSummaryModal] = useState(false);
  const [summaryHtml, setSummaryHtml] = useState('');
  const [loadingSummary, setLoadingSummary] = useState(false);
const[imageModalOpen, setImageModalOpen] = useState(false);
const[imagedata, setImageData] = useState(null);
const [labsModal,setLabsModal] = useState(false);
const [labsData,setLabsData] = useState(null);
const [loadingDetails, setLoadingDetails] = useState(false);
const [shareModalOpen, setShareModalOpen] = useState(false);
  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };

  const handleSummaryOpen = async (risk) => {
    try {
     
      setSummaryHtml('');
setLoadingDetails(true)

      const sourceNode = risk?.source_node_id?.[0];
      if (!sourceNode) throw new Error('Missing source_node_id');

      const parsed = JSON.parse(sourceNode);
      const { url, http_method, payload } = parsed;
      const relativeUrl = url.replace(/^https:\/\/[^/]+\/ag/, '');

      let response;
      if (http_method?.toLowerCase() === 'post') {
        response = await hubApi.post(relativeUrl, JSON.parse(payload));
      } else {
        response = await hubApi.get(relativeUrl);
      }

    if (response && typeof response === 'object' && 'files' in response) {
  setImageData(response);
  setImageModalOpen(true);
} else if (
  response &&
  typeof response === 'object' &&
  'data' in response &&
  typeof response.data === 'object' &&
  response.data !== null &&
  'dates' in response.data
) {
  console.log(response.data, 'labs data received');
  setLabsData(response.data || []);
  setLabsModal(true);
} else if (
  response &&
  typeof response === 'object' &&
  'data' in response &&
  typeof response.data === 'object' &&
  response.data !== null &&
  'summaryhtml' in response.data
) {
  setSummaryHtml(response.data || []);
  setOpenSummaryModal(true);
} else {
  console.warn("Unexpected response format:", response);
}

    } catch (error) {
      console.error('Error loading summary:', error);
      setSummaryHtml([]);
    } finally {
   setLoadingDetails(false)
    }
  };

  const handleCloseSummaryModal = () => {
    setOpenSummaryModal(false);
    setSummaryHtml('');
    setLoadingSummary(false);
  };

  return (
    <>
      {/* Risk Radar */}
      <div className="h-full w-full flex">
  <div className="bg-white text-xs p-2 text-start h-full w-full flex flex-col"
  style={{
    borderRadius: '8.75px',
    boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.25)',
    backdropFilter: 'blur(3px)',
    WebkitBackdropFilter: 'blur(3px)',
  }}
>

         <div className="flex justify-between items-center px-3 py-2 rounded-t-md">
                     {/* Left Side: Icon + Label + Issues */}
                     <div className="flex items-center gap-2 text-[#2C5282] font-semibold text-lg">
                       {riskfactor}
                       <span>Risk Factors</span>
                       
                     
                     </div>
                   
                     {/* Right Side: Share Icon */}
       {!view==1&&  <div onClick={() => setShareModalOpen(true)} className="cursor-pointer">
  {share}
</div>}
                   </div>

          {/* Risk Factors */}
          <div className="p-3 flex flex-col gap-2 flex-1">
            {patient_insights?.risk_radar?.risk_factors?.map((risk, index) => (
              <div
                key={`risk-${index}`}
                className={`border-b text-gray-700 flex justify-between items-center ${
                  view === 1 ? 'text-sm py-2' : 'text-xs py-1'
                }`}
              >
                <div
                  className="cursor-pointer flex-1"
                  onClick={() => {
                    setLabel('Risk Factor');
                    setSelectedAlert(risk);
                  }}
                >
                  {truncateText(risk.risk)}
                </div>
                { risk?.source_node_id?.[0]?<DescriptionOutlinedIcon
                  fontSize="small"
                  className="text-blue-500 ml-2 cursor-pointer hover:text-blue-600"
                  onClick={() => handleSummaryOpen(risk)}
                />:<></>}
              </div>
            ))}

           
          </div>
        </div>
      </div>

      {/* Alert Modal */}
      <AlertDetailsModal
        isOpen={!!selectedAlert}
        label={label}
        onClose={() => {
          setLabel('');
          setSelectedAlert(null);
        }}
        alert={selectedAlert}
      />
  {loadingDetails && (
  <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center">
    <div className="bg-white rounded-md p-6 shadow-md flex flex-col items-center gap-2">
      <span className="text-gray-700">Loading ...</span>
      <CircularProgress size={24} />
    </div>
  </div>
)}
<RiskRadarShareModal
  open={shareModalOpen}
  onClose={() => setShareModalOpen(false)}
  data={patient_insights}
/>

 <SummaryModal
        open={openSummaryModal}
        onClose={() => {
          setOpenSummaryModal(false);
          setSummaryHtml("");
        }}
        htmlContent={
          loadingDetails? (
            `<div class="flex justify-center items-center h-40"><div class="text-center"><svg class="animate-spin h-6 w-6 text-blue-600 mx-auto" viewBox="0 0 24 24"></svg><p>Loading...</p></div></div>`
          ) : (
            summaryHtml
          )
        }
      />
{imageModalOpen && imagedata && (<FileViewerModal open={imageModalOpen} onClose={()=>{
  setImageData(null)
  setImageModalOpen(false)
}} data={imagedata}/>)}
      {labsModal && !loadingDetails && labsData && (
        <FullScreenLabDetailsModal
          open={labsModal}
          onClose={() => {
            setLabsModal(false);
            setLabsData(null);
          }}
          data={labsData}
        />
      )}
    </>
  );
};

export default RiskRadar;
